import { FormControlOptions } from '../models/control-types';

const isTargetFormControlOption = (fco: FormControlOptions<any>, targetName: string): boolean =>
  fco != null && fco.name === targetName;

/**
 * Given a FormControlOptions object, find a FormControlOption object within it and it's children by name
 * @param formControlOptions
 * @param targetName
 * @returns FormControlOptions
 *
 * @example
 * // given
 * const fco = {
 *   name:'foo',type:'array'
 *   children: {
 *     bar: { name:'bar',type:'array'},
 *     baz: { name:'baz',type:'group'},
 *   }
 * }
 * // when
 * const targetFco = findFormControlOptionsByName(fco, 'baz')
 * // then
 * targetFco.name === 'baz' // true
 */
export function findFormControlOptionsByName<T = any>(
  formControlOptions: FormControlOptions<T>,
  targetName: string
): FormControlOptions<T> {
  if (isTargetFormControlOption(formControlOptions, targetName)) {
    // if target is current return given fco
    return formControlOptions;
  } else if (formControlOptions.children[targetName]) {
    // find within children target fco
    const nextFormControlOptions = formControlOptions.children[targetName];
    return findFormControlOptionsByName(nextFormControlOptions, targetName);
  }
  // not found
  return null;
}
